import React from 'react';
import { connect } from 'dva';
import PropTypes from 'prop-types'
import 'antd/lib/style/themes/default.less';
import { component_tool, framework_tool } from '@/tool'
let { WizAntdForm } = component_tool
let { WizContainer } = framework_tool
let { Item } = WizAntdForm
import WizTableForm from '../../common/wizTableForm/wizTableForm'

class WorkflowAuthSelectForm extends WizContainer {

    componentName = 'WorkflowAuthSelectForm';

    constructor(props) {
        super(props);
        this.state = {
            time: new Date().getTime()
        }
    }

    /**
     * 参数校验
     */
    static propTypes = {
        onChange: PropTypes.func,//参数变化时反馈数据的方法
        value: PropTypes.object,//初始化的默认值
    }

    propsAndStateOnChange = {
        value: this._value.bind(this)
    }

    /**
     * 监控value变化，进行渲染
     */
    _value(nextProps, nextState) {
        nextState['time'] = new Date().getTime()
        return true
    }



    /**
     * 值变化提交
     */
    _onSelect = (key, e) => {
        let { value, onChange } = this.props
        let v = []
        for (const key in e) {
            v.push(e[key])
        }
        value[key] = v
        onChange && onChange(value)
    }

    /**
     *  渲染选择组件
     */
    _select = (key, title, Config = {}) => {
        let { value } = this.props;
        let initProps = {
            initRows: value[key],
            value: value[key] && value[key].map(item => item['id'])
        }
        return (
            <Item
                label={title}
                labelCol={{ span: 4 }}
                wrapperCol={{ span: 15 }}
            >
                <WizTableForm
                    key={key + '@' + this.state.time}
                    {...Config}
                    onChangeRowMap={(e) => this._onSelect(key, e)}
                    {...initProps}
                />
            </Item>
        )
    }


    _render() {
        const {value} = this.props;
        return (
            <>
            {this._select('orgIds', '组织选择', { allowTreeSelect: true , ...WizTableForm.Config.organization(this, { state: 1 }) })}
            {this._select('positionIds', '岗位选择', WizTableForm.Config.position(this, {}))}
            {this._select('positionCategoryIds', '岗位分类选择', WizTableForm.Config.positionCategory(this, {}))}
            {this._select('personIds', '人员选择', WizTableForm.Config.user(this, {}))}
            {value['methodIds']?this._select('methodIds', '方法选择', WizTableForm.Config.workflowAuditMethod(this, {apiParams: {state: 1}})):null}
            </>

        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
    };
};

const options = { withRef: true };

export default connect(mapStateToProps, null, null, options)(WorkflowAuthSelectForm);
